export default __webpack_public_path__ + "media/images/mailer/logo_transparent-73bf4bea5ad08ce44d516e472dc452c1.png";